/**
 * Global configuration for the Member Management System
 * Contains environment-specific settings and constants
 */

// Get current frontend base URL
const getFrontendBaseUrl = () => {
  const { protocol, hostname, port } = window.location;
  const portSuffix = port && port !== '80' && port !== '443' ? `:${port}` : '';
  return `${protocol}//${hostname}${portSuffix}`;
};

// Determine environment
const isProduction = import.meta.env.MODE === 'production';

// Frontend Base URL (for sending to backend for email templates)
export const FRONTEND_BASE_URL = getFrontendBaseUrl();

const deriveApiUrl = () => {
  const configuredApiUrl = (import.meta.env.VITE_API_URL || '').trim();
  const localFallback = (import.meta.env.VITE_LOCAL_API_URL || 'http://127.0.0.1:8000/api').trim();

  if (typeof window === 'undefined') {
    return configuredApiUrl || localFallback;
  }

  const hostname = window.location.hostname;
  const isLocalHost =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost');

  if (isLocalHost) {
    return localFallback;
  }

  return configuredApiUrl || localFallback;
};

// API URLs: Use environment variables or fallback to defaults
export const API_URL = deriveApiUrl();

// Disable mock authentication - using real backend now
export const USE_MOCK_AUTH = import.meta.env.VITE_ENABLE_MOCK_AUTH === 'true' || false;

// Critical debugging information - this will show immediately in console
console.log('🚀 ENVIRONMENT CONFIG:', {
  hostname: window.location.hostname,
  isProduction,
  frontendBaseUrl: FRONTEND_BASE_URL,
  selectedApiUrl: API_URL,
  mockAuthEnabled: USE_MOCK_AUTH
});

// Force an additional log to ensure visibility
setTimeout(() => {
  console.warn('⚠️ BACKEND URL CONFIRMATION:', API_URL);
  console.warn('🌐 FRONTEND BASE URL:', FRONTEND_BASE_URL);
}, 1000);

// Authentication constants
export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const USER_KEY = 'user_info';
export const MEMBERSHIP_KEY = 'membership_info';

// Application settings
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Member Management System';
export const COPYRIGHT_YEAR = new Date().getFullYear();
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

// Feature flags
export const FEATURES = {
  EVENT_REGISTRATION: true,
  MEMBERSHIP_RENEWAL: true,
  USER_PROFILES: true
};
